import { MockDatabase, MockRecord, MockTable } from "../MockDatabase";
import { JSONSchema7 } from 'json-schema';

export type SchemaTypeAPI = {
    schema_type: string;
    schema_type_version: number;
    schema: JSONSchema7;
}

export class MockSchemaType extends MockTable {
    constructor(db: MockDatabase) {
        super(db);
        this.name = 'schema_type';
        this.fields = {
            id: this.PrimaryKey({
                fieldName: 'id'
            }),
            schema_type_name_id: this.ForeignKey({
                fieldName: 'schema_type_name_id',
                nullable: false,
                index: true,
                foreignTableName: 'schema_type_name',
                foreignTableFieldName: 'id',
            }),
            schema_type_version: this.Field({
                type: 'number',
                fieldName: 'schema_type_version',
                nullable: false
            }),
            schema: this.Field({
                type: 'string',
                fieldName: 'schema',
                nullable: true
            }),
            latest: this.Field({
                type: 'number',
                fieldName: 'latest',
                nullable: true,
            }),
            created_date: this.Field({
                type: 'datetime',
                fieldName: 'created_date',
                nullable: false,
                default: {
                    method: 'NOW'
                }
            }),
            updated_date: this.Field({
                type: 'datetime',
                fieldName: 'updated_date',
                nullable: false,
                default: {
                    method: 'NOW',
                    onUpdate: true
                }
            }),
        }
    }

    protected afterCreate: (db: MockDatabase, table: MockTable, records: MockRecord[]) => void = (db: MockDatabase, table: MockTable, records: MockRecord[]) => {
        // Handle latest logic
        const prevRec = table.query([
            {fieldName: 'schema_type_name_id', value: records[0].values['schema_type_name_id']}
        ]);
        prevRec.forEach(prev => prev.update(db, table, {
            latest: 0
        }));
        records[0].values['latest'] = 1;
    }

    protected afterDelete: (db: MockDatabase, table: MockTable, records: MockRecord[]) => void = (db: MockDatabase, table: MockTable, records: MockRecord[]) => {
        // Handle "latest" logic
        const schemaDataIds = records.reduce((acc, cur) => {
            const dataId = cur.values['schema_type_name_id'];
            if (acc.indexOf(dataId) === -1) {
                acc.push(dataId);
            }
            return acc;
        }, [] as string[]);
        const updateRecs = schemaDataIds.reduce((acc, cur) => {
            acc.push(...table.query([
                {fieldName: 'schema_type_name_id', value: records[0].values['schema_type_name_id']}
            ]));
            return acc;
        }, [] as MockRecord[]);
        table.updateRecords(updateRecs, {
            latest: 0
        });
    }
}